module.exports = __webpack_public_path__ + "a9d8babcf1aa0393fd30c5a531f6c899.jpg";